import { render, staticRenderFns } from "./AddVersionDialog.vue?vue&type=template&id=de33df94&"
import script from "./AddVersionDialog.js?vue&type=script&lang=js&"
export * from "./AddVersionDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports